import * as React from "react";
import { Component } from "react";
import { MDBIcon, MDBContainer, MDBCard, MDBCardBody, MDBCardHeader, MDBCollapse, } from 'mdbreact';
import { URLImgFront } from '../../../config/URLDB';

import { SegurosConfigPreguntas_ } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';
import AOS from 'aos';
import 'aos/dist/aos.css';

class PreguntasFrecuentesSeguros extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openItems: {},
            preguntas: []
        };
    }

    async componentDidMount() {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: false,
        });
        await this.ObtenerPreguntas();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.estado !== this.props.estado) {
            this.ObtenerPreguntas();
        }
    }

    ObtenerPreguntas = async () => {
        const { estado } = this.props;
        const tipo = estado ? 1 : 2;
        const data = {
            tran: 5,
            idsegupregunta: 0,
            idtiposeguro: tipo,
            titulo: 'NA',
            descripcion: 'NA',
            orden: 0,
            estado: 1,
            idusucrea: 0,
            feccrea: null,
        };

        try {
            const response = await SegurosConfigPreguntas_(data);
            if (response.data.length > 0 && !response.data[0].message) {
                const preguntas = response.data.map(item => ({
                    id: item.idsegupregunta,
                    titulo: item.titulo,
                    descripcion: item.descripcion,
                    url: item.rutaconfig || null,
                }));
                this.setState({ preguntas });

            } else {
                this.setState({ preguntas: [] });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                text: 'Ocurrió un error al consumir el servicio'
            });
        }
    };

    toggleItem = (id) => {
        this.setState(prevState => ({
            openItems: {
                ...prevState.openItems,
                [id]: !prevState.openItems[id]
            }
        }));
    };

    render() {
        const { preguntas, openItems } = this.state;
        const { estado } = this.props;

        return (
            <MDBContainer className="mb-4 p-4">
                <div data-aos="zoom-out"
                    style={{ overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', maxHeight: '80vh' }}>
                    <img style={{ width: '100%', height: 'auto', maxWidth: '150px', maxHeight: '100%', objectFit: 'contain', padding: '10px 10px 10px 10px', }} className="img-fluid" src={`${URLImgFront}/assets/Seguros/PreguntasFrecuentes.svg`} alt="Preguntas Frecuentes"/>
                </div>
                {preguntas.map((item) => (
                    <MDBCard key={item.id} className="mb-3" style={{ borderRadius: '40px', overflow: 'hidden' }}>
                        <MDBCardHeader onClick={() => this.toggleItem(item.id)} className="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer', backgroundColor: '#2CA02C', color: '#ffffff', fontWeight: 'bold' }}>

                            <span style={{ width: '100%', textAlign: 'center', font: 'normal normal 400 23px/40px Montserrat, sans-serif', letterSpacing: '0px', color: '#FFFFFF', opacity: '1', fontWeight: 'bold' }} >{item.titulo}  </span> 
                            <MDBIcon icon={openItems[item.id] ? 'angle-up' : 'angle-down'} style={{ color: '#ffffff', with: '20px', height:'20px' }} />
                        </MDBCardHeader>

                        <MDBCollapse isOpen={openItems[item.id]}>
                            <MDBCardBody><>
                                <p style={{ font: 'normal normal 400 23px/40px Montserrat, sans-serif', backgroundColor: '#ffffff', textAlign: 'center', letterSpacing: '-1.25px', color: '#707070' }}
                                    dangerouslySetInnerHTML={{ __html: item.descripcion }}
                                />
                            </>
                            </MDBCardBody>
                        </MDBCollapse>
                    </MDBCard>
                ))}
                {estado && (
                    <p style={{ font: 'normal normal 400 23px/40px Montserrat, sans-serif', backgroundColor: '#ffffff', textAlign: 'center', letterSpacing: '-1.25px', color: '#707070', paddingTop: '40px' }} >
                        En caso de requerir servicios adicionales no contemplados en el contrato con EMCOOFUN, el valor excedente deberá ser asumido por el afiliado principal, los familiares o quienes soliciten el servicio funerario.
                    </p>
                )}
            </MDBContainer>
        );
    }
}

export default PreguntasFrecuentesSeguros;